import Heading from '@zenbusiness/zui/Heading';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import FormModal from '#client/components/FormModal';

const WistaVideoContainerStyle = () => ({
  width: '100%',
  maxWidth: '1200px',
  margin: 'auto'
});

const FormModalStyle = () => ({
  width: '100%'
});

const OuterContainerStyle = ({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: `${theme.palette.fixed.black}`,
  padding: '0 120px',
  [theme.breakpoints.down('lg')]: {
    padding: '0 30px'
  },
  [theme.breakpoints.down('md')]: {
    padding: '0 16px'
  }
});

const TitleStyle = ({ theme }) => ({
  color: `${theme.palette.text.primary}`,
  textAlign: 'center',
  padding: '16px 0',
  [theme.breakpoints.down('md')]: {
    padding: '13px 0'
  }
});

const TranscriptContainerStyle = ({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '80px 320px',
  [theme.breakpoints.down('lg')]: {
    padding: '64px 64px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '64px 16px'
  }
});

const SubtitleStyle = ({ theme }) => ({
  paddingTop: '80px',
  paddingBottom: '24px',
  [theme.breakpoints.down('lg')]: {
    paddingTop: '40px',
    paddingBottom: '24px'
  }
});

export const WistaVideoContainer = styled('div')(WistaVideoContainerStyle);
export const OuterContainer = styled('div')(OuterContainerStyle);
export const FormModalStyled = styled(FormModal)(FormModalStyle);
export const TitleStyled = styled(Text)(TitleStyle);
export const SubtitleStyled = styled(Heading)(SubtitleStyle);
export const TranscriptContainer = styled('div')(TranscriptContainerStyle);
